export default "__VITE_ASSET__BZGiyUwH__"